import { AsyncPipe, NgIf, NgPlural, NgPluralCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-table-results-text',
  templateUrl: './table-results-text.component.html',
  styleUrls: ['./table-results-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, NgPlural, NgPluralCase]
})
export class TableResultsTextComponent implements OnChanges {
  @Input() totalCount!: number;
  @Input() pageSize: number | null = 10;
  @Input() skip: number = 0;

  private _pageSize = new BehaviorSubject<number | null>(null);
  public pageSize$ = this._pageSize as Observable<number | null>;

  private _totalCount = new BehaviorSubject<number>(0);
  public totalCount$ = this._totalCount as Observable<number>;

  private _skip = new BehaviorSubject<number>(0);
  public skip$ = this._skip as Observable<number>;

  public showingFrom$ = combineLatest([this.skip$, this.totalCount$]).pipe(
    map(([skip, totalCount]) => (totalCount && totalCount > 0 ? skip + 1 : 0))
  );

  public showTo$ = combineLatest([this.skip$, this.pageSize$, this.totalCount$]).pipe(
    map(([skip, pageSize, totalCount]) => {
      if (!totalCount || totalCount <= 0) return 0;
      if (pageSize === null) return totalCount;
      return Math.min(skip + pageSize, totalCount);
    })
  );

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageSize) {
      this._pageSize.next(this.pageSize);
    }
    if (changes.totalCount) {
      this._totalCount.next(this.totalCount);
    }
    if (changes.skip) {
      this._skip.next(this.skip);
    }
  }
}
